import Image from "../images/medcrum-main.svg";
import Logo from "../images/medcrum.jpeg";

const AuthImage = ({ isLogo=false, ...props }) => {
  return (
    <img
    {...props}
    src={!isLogo ? Image : Logo}
    alt="Auth_Image" />
  )
}

export default AuthImage
